import type { IScriptAndStyle } from "../../../models/Interfaces";

export const EDITOR_CHILD_LOADED = "sbcms-editor-loaded";
export const EDITOR_PARENT_STYLES = "sbcms-editor-styles";
export const EDITOR_CHILD_READY = "sbcms-editor-ready";
export const EDITOR_CHILD_CHANGE = "sbcms-editor-change";
export const EDITOR_CHILD_OVERLAY = "sbcms-editor-overlay";
export const EDITOR_CHILD_FULLSCREEN = "sbcms-editor-fullscreen";
export const EDITOR_CHILD_HEIGHT = "sbcms-editor-height";
export const EDITOR_PARENT_INIT = "sbcms-editor-init";
export const EDITOR_PARENT_SET = "sbcms-editor-set";
export const EDITOR_PARENT_LISTS = "sbcms-editor-lists";

export interface IEditorMenuMessage {
  name: string;
  text: string;
  items: Array<{ text: string; insertText: string }>;
}

/** Stored client scripts for the open site, in load order. External addresses are left out. */
export const enabledClientScriptCode = (
  scripts: Array<Pick<IScriptAndStyle, "Enabled" | "Code" | "LoadOrder">>
): string[] => {
  return [...scripts]
    .filter((script) => script.Enabled && Boolean(script.Code?.trim()))
    .sort((left, right) => (left.LoadOrder ?? 0) - (right.LoadOrder ?? 0))
    .map((script) => script.Code!.trim());
};
